import {Link} from 'react-router-dom';
import Header from '../../../components/header';
import SupportImg from '../../../assets/image/profile/support.svg';
import styles from './support.module.scss';
import classNames from 'classnames';
const Support = () => {
  return (
    <>
      <Header title="پشتیبانی" />

      <div
        className={classNames('px-3  d-flex flex-column', styles['support'])}
      >
        <div className="flex-fill">
          <div className="my-4">
            <Link to="/profile/support/faq" className="text-decoration-none">
              <div className="d-flex align-items-center">
                <i className="icon-interrogation color-primary"></i>
                <small className="pe-2 color-gray-1">سوالات متداول</small>
              </div>
            </Link>
          </div>
          <div className="my-4">
            {/* <Link to="/profile/support/rules" className="text-decoration-none"> */}
            {/* <div className="d-flex align-items-center">
              <i className="icon-chat color-primary"></i>
              <small className="pe-2 color-gray-1">گفت و گوی آنلاین </small>
            </div> */}
            {/* </Link> */}
          </div>
          <div className="my-4">
            <a href="tel:09352593515" className="text-decoration-none">
              <div className="d-flex align-items-center">
                <i className="icon-contact color-primary"></i>
                <small className="pe-2 color-gray-1"> تماس با ما</small>
              </div>
            </a>
          </div>
        </div>

        <div className="text-center">
          <img src={SupportImg} alt="support" />
        </div>
      </div>
    </>
  );
};

export default Support;
